// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UhaN","newExpiryDate":"styles_newExpiryDate__3zQPn","footer":"styles_footer__1wjip"};